import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import 'vuetify/styles';
import { aliases, md } from 'vuetify/iconsets/md';
import { mdi } from 'vuetify/iconsets/mdi';
import { VCalendar } from 'vuetify/labs/VCalendar';
import { getCookie, setCookie } from '@/lib/utils';

const readThemeCookie = () => {
  if (!getCookie('theme')) setCookie('theme', 'system', 365);
  const theme = getCookie('theme');

  let t = theme;
  if (theme === 'system') {
    const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    t = isDark ? 'dark' : 'light';
  }

  return t;
};

// Setting 'defaultTheme' to 'system' causes Vuetify to use the default dark mode instead of our custom one,
// therefore we translate it here and track the true theme state in a cookie
const defaultTheme = readThemeCookie();

export default createVuetify({
  defaults: {
    VCheckbox: {
      color: 'primary',
    },
    VCheckboxBtn: {
      color: 'primary',
    },
  },
  theme: {
    defaultTheme,
    themes: {
      dark: {
        dark: true,
        colors: {
          background: '#1e222c',
          surface: '#2e323d',
          'surface-variant': '#8F9FC7',
          'surface-light': '#3B4156',
          'surface-bright': '#48516A',

          secondary: '#A9AFCB',
          'secondary-darken-1': '#8F95B2',

          error: '#DE3655',

          'on-background': '#E6E9F8',
          'on-surface': '#E6E9F8',
          'on-primary': '#FFFFFF',
          'on-secondary': '#0B0D13',

          border: '#737fA8',

          'ra-blue': '#383E7A',
        },
      },
      light: {
        dark: false,
        colors: {
          success: '#A5D6A7',
          error: '#F44336',
          warning: '#E48709',

          'ra-blue': '#2A2E58',
        },
      },
    },
  },
  icons: {
    defaultSet: 'md',
    aliases,
    sets: {
      md,
      mdi,
    },
  },
  components: {
    ...components,
    VCalendar,
  },
  directives,
});
